import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerDocumentForm from '../containers/PlannerDocumentFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerDocumentAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerDocumentAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_documents_route_add')} />
          <PlannerDocumentForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerDocumentAddScreen;

Logger.log('silly', `PlannerDocumentAddScreen loaded.`);
